import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeInsert: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCodeInsert"><Path d="M13.25 4.75H5.75C4.09315 4.75 2.75 6.09315 2.75 7.75V16.25C2.75 17.9069 4.09315 19.25 5.75 19.25H13.25M16.2454 4.75H18.2454C19.9022 4.75 21.2454 6.09315 21.2454 7.75V16.25C21.2454 17.9069 19.9022 19.25 18.2454 19.25H16.2454M16.2454 4.75V2.5M16.2454 4.75V19.25M16.2454 19.25V21.5M8.5 9.5L11 12L8.5 14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconCodeInsert;
